import { State } from 'app/gamma/src/modules';
import { cancelAlert } from 'app/gamma/src/modules/state/ui/alerts';
import React from 'react';
import { connect } from 'react-redux';
import { Transition } from 'react-transition-group';
import { Dispatch } from 'redux';
import { isAlertShown } from 'app/gamma/src/selectors/alerts';
import { LayerManagerPortal, Layers } from '../layer-manager';
import Alert, { AlertProps } from './alert';

interface DispatchProps {
  removeAlert: (alertArea: string) => void;
}

interface StateProps {
  isActive: boolean;
}

interface AllProps extends DispatchProps, StateProps, AlertProps {}

export class AlertContainerUnconnected extends React.Component<AllProps> {
  defaultTimeout = 5000;

  render() {
    const { children, isActive, removeAlert, ...rest } = this.props;

    return (
      <LayerManagerPortal layer={Layers.Alert}>
        <Transition
          appear
          in={isActive}
          onEntered={() => removeAlert(this.props.area)}
          timeout={this.props.msTimeout || this.defaultTimeout}
        >
          {(state) => {
            if (state === 'entering') {
              return <Alert {...rest}>{children}</Alert>;
            } else {
              return '';
            }
          }}
        </Transition>
      </LayerManagerPortal>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch<State>): DispatchProps => {
  return {
    removeAlert(alertArea) {
      dispatch(cancelAlert({ alertArea }));
    },
  };
};

const mapStateToProps = (state: State, ownProps: AlertProps): StateProps => {
  return {
    isActive: isAlertShown(state, ownProps.area, ownProps.name),
  };
};

export const AlertContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertContainerUnconnected);
